import React from "react";
import classNames from "classnames";
import Size from "shared/enums/Size";
import ToolTip from "../../../components/tooltip";
import { SchemaField } from "../types/SchemaField";
import { removeHtmlTagsFromString } from "shared/utils";
import Conditional from "../../../components/conditional";
import DisplayIcon from "shared/form/core/displayIcon";
import Button from "shared/components/button";
import Variant from "shared/enums/Variant";

/**
 * @name DynamicFieldLabel this will be used to display label & secondary label on each field
 * @param props
 * @constructor
 */
export default function DynamicFieldLabel(props: {
  className?: string;
  showTitle?: boolean;
  schemaObj: SchemaField;
  editHandler?: () => void;
}) {
  const secondaryLabel = React.useMemo(() => {
    if (!props.schemaObj.secondaryLabel) {
      return "";
    }
    return getSecondaryLabelTemplate({ secondaryLabel: props.schemaObj.secondaryLabel });
  }, [props.schemaObj.secondaryLabel]);

  const primaryLabelTitle = React.useMemo(() => {
    return props.showTitle ? removeHtmlTagsFromString(props.schemaObj.label) : "";
  }, [props.showTitle, props.schemaObj.label]);

  const secondaryLabelTitle = React.useMemo(() => {
    return props.showTitle ? removeHtmlTagsFromString(secondaryLabel) : "";
  }, [props.showTitle, secondaryLabel]);

  return (
    <label
      className={classNames("dynamicLabel", props.className, {
        "dynamicLabel--required": props.schemaObj.mandatory,
        hasIcon: props.schemaObj.imageIcon
      })}>
      <label>
        {props.schemaObj.imageIcon && <DisplayIcon iconUrl={props.schemaObj.imageIcon?.url} />}
        <span className="dynamicLabel_primaryLabelWrapper">
          <span
            title={primaryLabelTitle}
            className="dynamicLabel_primaryLabel"
            dangerouslySetInnerHTML={{ __html: props.schemaObj.label }}
          />
          {props.schemaObj.mandatory && <span className="dynamicLabel_asterisk"></span>}
          <Conditional test={!!secondaryLabel}>
            <span
              title={secondaryLabelTitle}
              className="form_label_additionalNote"
              dangerouslySetInnerHTML={{ __html: secondaryLabel }}
            />
          </Conditional>
          <Conditional test={!!props.schemaObj.infoLabel}>
            <ToolTip
              size={Size.SMALL}
              content={<span dangerouslySetInnerHTML={{ __html: props.schemaObj.infoLabel || "" }} />}></ToolTip>
          </Conditional>
          {props.editHandler && (
            <Button.Edit
              variant={Variant.LINK}
              label={""}
              className="dynamicLabel_editButton"
              onClick={props.editHandler}
            />
          )}
        </span>
      </label>
    </label>
  );
}

export function getSecondaryLabelTemplate(props: { secondaryLabel: string }) {
  return `<i>${props.secondaryLabel}</i>`;
}
